import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { TOKEN } from '../../_helpers/token';
import { Link } from 'react-router-dom';
import * as moment from 'moment';

export class CustomerCalledStatus extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [

            {
                key: "dates",
                TrOnlyClassName: 'tsc',
                text: "TIME",
                className: "tsc",
                align: "left"
            },

            {
                key: "msisdn",
                TrOnlyClassName: 'tsc',
                text: "MobileNo",
                className: "tsc",
                align: "left"
            },

            {
                key: "status",
                TrOnlyClassName: 'tsc',
                text: "Status",
                className: "tsc",
                align: "left"
            },


            {
                key: "description",
                TrOnlyClassName: 'tsc',
                text: "Description",
                className: "tssc",
                align: "left"
            },
            // {

            //     key: "CustomerCalledStatus",
            //     TrOnlyClassName: 'tsc',
            //     text: "Called Status",
            //     className: "tsc",
            //     align: "left"
            // }
        ];
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50, 100, 150, 200, 300, 500],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 10,
            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                filter: "Enter ID...",
                no_data_text: "No data was found",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData = (queryString = "") => {
        this.setState({
            isLoading: true,
        })
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Authorization": TOKEN
            }
        };
        let url = baseURL + "calledstatus?mobile=" + localStorage.getItem("phone") + '&' + queryString
        console.log("query", url);
        axios.get(url, axiosConfig, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        })
            .then((branchResponse) => {
                this.setState({
                    admins: branchResponse.data.data,
                    total: branchResponse.data.total,
                    isLoading: false,
                }, function () {
                    // alert(JSON.stringify(branchResponse.data))

                    var data = [];
                    console.log("BUG", this.state.admins)

                    for (let i = 0; i < this.state.admins.length; i++) {
                        let mail;
                        let mbalance;
                        if (this.state.admins[i].sent == null) {
                            mail = { mail: "_" };
                        } else {

                            if (this.state.admins[i].sent.toString() == "1") {
                                mail = { mail: "Yes" }
                            } else {

                                mail = { mail: "No" }
                            }
                        }
                        if (this.state.admins[i].status === null) {
                            mbalance = { mbalance: "null" };
                        } else {
                            mbalance = { mbalance: this.state.admins[i].balance };
                        }
                        let date = { dates: moment.utc(this.state.admins[i].TIME).format("DD-MMM-yyyy HH:mm:ss") };
                        let date1 = { dates1: moment.utc(this.state.admins[i].out_time).format("DD-MMM-yyyy HH:mm:ss") };

                        data.push(Object.assign(mail, mbalance, date, date1, this.state.admins[i]));
                        this.setState({
                            data: data
                        })

                        console.log("bugs", data);
                    }


                }
                );
            })
    }

    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(queryString);
    }


    render() {
        // console.log("Load", isLoading);
        return (
            < Card >
                <CardBody >

                    <div className="panel-body" >
                        <div className="row">
                            <div className="col-6">
                                <h4>MTN Deposits (Status Failed/Blank)</h4>
                                <br />

                            </div>

                        </div>

                        <ReactDatatable
                            config={this.config}
                            records={this.state.data}
                            columns={this.columns}
                            dynamic={true}
                            id="tsc"
                            loading={this.state.isLoading}
                            total_record={this.state.total}
                            onChange={this.tableChangeHandler} />
                    </div>
                </CardBody>

            </Card>
        )
    }
}